export default __webpack_public_path__ + "static/media/ponto_5.bcfd6173.svg";